import React from "react";
import {PricingContent} from "../../../components/apps/public/pricing/PricingContent";

export const PricingPage = () => {

    return <PricingContent/>

}
